export const loginResponseStatus = {
  AUTHENTICATION_SUCCESS: 'AUTHENTICATION_SUCCESS',
  AUTHENTICATION_FAILURE: 'AUTHENTICATION_FAILURE',
  AUTHORIZATION_FAILURE: 'AUTHORIZATION_FAILURE',
};
